// src/data/planning/targetActivityCatalog.js

/**
 * REHBER360 - RESMÎ HEDEF FAALİYET HAVUZU
 *
 * OTOMATİK OLUŞTURULMUŞTUR.
 *
 * Kaynak:
 * - MEB RPD Hizmetleri Sunum Sistemi EK-1
 * - Daha yeni e-Rehberlik kılavuzunda doğrulanan
 *   ek resmî seçenekler
 *
 * Faaliyet adı serbest metinle üretilemez.
 */

export const TARGET_ACTIVITY_CATALOG_VERSION =
  "RPDH-TARGET-2020+2025+MEBBIS-2026-2027-V3";


export const TARGET_ACTIVITY_CATALOG =
[
  {
    "id": "student_social_emotional_tbm_alkol_bagimliligi",
    "officialLabel": "(TBM) Alkol Bağımlılığı",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T24"
      ]
    }
  },
  {
    "id": "student_social_emotional_tbm_kumar_bagimliligi",
    "officialLabel": "(TBM) Kumar Bağımlılığı",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "E_REHBERLIK_GUIDE",
      "version": "2025-2026",
      "printedPage": 15
    }
  },
  {
    "id": "student_social_emotional_tbm_madde_bagimliligi",
    "officialLabel": "(TBM) Madde Bağımlılığı",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T26"
      ]
    }
  },
  {
    "id": "student_social_emotional_tbm_saglikli_yasam",
    "officialLabel": "(TBM) Sağlıklı Yaşam",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T28"
      ]
    }
  },
  {
    "id": "student_social_emotional_tbm_teknoloji_bagimliligi",
    "officialLabel": "(TBM) Teknoloji Bağımlılığı",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T30"
      ]
    }
  },
  {
    "id": "student_social_emotional_tbm_tutun_bagimliligi",
    "officialLabel": "(TBM) Tütün Bağımlılığı",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T32"
      ]
    }
  },
  {
    "id": "student_social_emotional_aile_ici_iletisim",
    "officialLabel": "Aile İçi İletişim",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S8"
      ]
    }
  },
  {
    "id": "student_academic_akademik_ozyeterlik",
    "officialLabel": "Akademik Özyeterlik",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U8"
      ]
    }
  },
  {
    "id": "student_social_emotional_akran_arabuluculugu",
    "officialLabel": "Akran Arabuluculuğu",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S9"
      ]
    }
  },
 {
  "id": "student_social_emotional_akran_zorbaligi",
  "officialLabel": "Akran Nezaketi",
  "audience": "student",
  "developmentArea": "social_emotional",
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
  {
    "id": "student_social_emotional_alkol_bagimliligini_onleme",
    "officialLabel": "Alkol Bağımlılığını Önleme",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T25"
      ]
    }
  },
  {
    "id": "student_social_emotional_atilganlik",
    "officialLabel": "Atılganlık",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S11"
      ]
    }
  },
  {
    "id": "student_social_emotional_bilincli_teknoloji_kullanimi",
    "officialLabel": "Bilinçli Teknoloji Kullanımı",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S12"
      ]
    }
  },
  {
    "id": "student_career_bir_meslek_elemanini_sinifa_okula_davet_etme",
    "officialLabel": "Bir Meslek Elemanını Sınıfa/Okula Davet Etme",
    "audience": "student",
    "developmentArea": "career",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "V8"
      ]
    }
  },
  {
    "id": "student_social_emotional_bireysel_farkliliklara_saygi",
    "officialLabel": "Bireysel Farklılıklara Saygı",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S13"
      ]
    }
  },
  {
    "id": "student_career_calisan_isveren_hak_ve_sorumluluklari",
    "officialLabel": "Çalışan/işveren Hak ve Sorumlulukları",
    "audience": "student",
    "developmentArea": "career",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "V10"
      ]
    }
  },
  {
    "id": "student_academic_calisma_programi_hazirlama",
    "officialLabel": "Çalışma Programı Hazırlama",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U9"
      ]
    }
  },
  {
    "id": "student_social_emotional_catisma_cozme_becerileri",
    "officialLabel": "Çatışma Çözme Becerileri",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S14"
      ]
    }
  },
  {
    "id": "student_career_cevredeki_is_olanaklari_ve_calisma_kosullari",
    "officialLabel": "Çevredeki İş Olanakları ve Çalışma Koşulları",
    "audience": "student",
    "developmentArea": "career",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "V12"
      ]
    }
  },
  {
    "id": "student_social_emotional_cocuklarda_cinsel_egitim",
    "officialLabel": "Çocuklarda Cinsel Eğitim",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S15"
      ]
    }
  },
  {
    "id": "student_social_emotional_degisen_yasam_kosullarina_uyum",
    "officialLabel": "Değişen Yaşam Koşullarına Uyum",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S16"
      ]
    }
  },
  {
    "id": "student_academic_ders_secimi",
    "officialLabel": "Ders Seçimi",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U10"
      ]
    }
  },
  {
    "id": "student_academic_devamsizligi_onleme",
    "officialLabel": "Devamsızlığı Önleme",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U11"
      ]
    }
  },
  {
    "id": "student_academic_dikkat_gelistirme_calismalari",
    "officialLabel": "Dikkat Geliştirme Çalışmaları",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U12"
      ]
    }
  },
  {
    "id": "student_academic_dogru_bilgi_kaynaklari_yok_atlas_osym_tubitak_vb",
    "officialLabel": "Doğru Bilgi Kaynakları (YÖK ATLAS, ÖSYM, TÜBİTAK vb.)",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U13"
      ]
    }
  },
  {
    "id": "student_social_emotional_duygu_duzenleme",
    "officialLabel": "Duygu Düzenleme",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S18"
      ]
    }
  },
  {
    "id": "student_social_emotional_duygu_farkindaligi",
    "officialLabel": "Duygu Farkındalığı",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S19"
      ]
    }
  },
  {
    "id": "student_social_emotional_duygu_kontrolu",
    "officialLabel": "Duygu Kontrolü",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S17"
      ]
    }
  },
  {
    "id": "student_academic_e_kpss",
    "officialLabel": "E-KPSS",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U15"
      ]
    }
  },
  {
    "id": "student_social_emotional_elestirel_dusunme_becerisi",
    "officialLabel": "Eleştirel Düşünme Becerisi",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S21"
      ]
    }
  },
  {
    "id": "student_social_emotional_elestiriye_tolerans_gosterme",
    "officialLabel": "Eleştiriye Tolerans Gösterme",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S20"
      ]
    }
  },
  {
    "id": "student_social_emotional_ergenleri_bilgilendirme_ve_farkindalik_kazandirma_prog",
    "officialLabel": "Ergenleri Bilgilendirme ve Farkındalık Kazandırma Eğitim Programı",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S22",
        "S23"
      ]
    }
  },
  {
    "id": "student_social_emotional_etik_davranis",
    "officialLabel": "Etik Davranış",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S24"
      ]
    }
  },
  {
    "id": "student_social_emotional_gelecegi_planlama",
    "officialLabel": "Geleceği Planlama",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S25"
      ]
    }
  },
  {
    "id": "student_social_emotional_gelisim_donemi_ozellikleri",
    "officialLabel": "Gelişim Dönemi Özellikleri",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S26"
      ]
    }
  },
  {
    "id": "student_social_emotional_girisimcilik",
    "officialLabel": "Girişimcilik",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S27"
      ]
    }
  },
  {
    "id": "student_social_emotional_hak_ve_sorumluluklarini_bilme",
    "officialLabel": "Hak ve Sorumluluklarını Bilme",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S28"
      ]
    }
  },
  {
    "id": "student_academic_hedef_belirleme",
    "officialLabel": "Hedef Belirleme",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U16"
      ]
    }
  },
  {
    "id": "student_social_emotional_ihmal_istismardan_korunma",
    "officialLabel": "İhmal ve İstismar Farkındalığı",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S29"
      ]
    }
  },
  {
    "id": "student_social_emotional_iletisim_becerileri",
    "officialLabel": "İletişim Becerileri",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S30"
      ]
    }
  },
  {
    "id": "student_career_is_gorusmesi_becerileri",
    "officialLabel": "İş Görüşmesi Becerileri",
    "audience": "student",
    "developmentArea": "career",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "V14"
      ]
    }
  },
  {
    "id": "student_career_is_ve_meslege_hazirlayan_kurum_ve_kurslarin_tanitimi",
    "officialLabel": "İş ve Mesleğe Hazırlayan Kurum ve Kursların Tanıtımı",
    "audience": "student",
    "developmentArea": "career",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "V15"
      ]
    }
  },
  {
    "id": "student_career_is_ve_meslek_etigi",
    "officialLabel": "İş ve Meslek Etiği",
    "audience": "student",
    "developmentArea": "career",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "V17"
      ]
    }
  },
  {
    "id": "student_career_is_yasamina_yonelik_beceriler",
    "officialLabel": "İş Yaşamına Yönelik Beceriler",
    "audience": "student",
    "developmentArea": "career",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "V18"
      ]
    }
  },
  {
    "id": "student_social_emotional_isbirligi_gelistirme",
    "officialLabel": "İşbirliği Geliştirme",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S31"
      ]
    }
  },
  {
    "id": "student_social_emotional_kadina_yonelik_siddetin_onlenmesi",
    "officialLabel": "Kadına Yönelik Şiddetin Önlenmesi",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S33"
      ]
    }
  },
  {
    "id": "student_career_kalfalik_ve_ustalik_sistemleri_hakkinda_bilgilendirme",
    "officialLabel": "Kalfalık ve Ustalık Sistemleri Hakkında Bilgilendirme",
    "audience": "student",
    "developmentArea": "career",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "V19",
        "V20"
      ]
    }
  },
  {
    "id": "student_social_emotional_karar_verme_becerisi",
    "officialLabel": "Karar Verme Becerisi",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S32"
      ]
    }
  },
  {
    "id": "student_career_kariyer_gelisimi",
    "officialLabel": "Kariyer Gelişimi",
    "audience": "student",
    "developmentArea": "career",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "V23"
      ]
    }
  },
  {
    "id": "student_career_kariyer_olgunlugu",
    "officialLabel": "Kariyer Olgunluğu",
    "audience": "student",
    "developmentArea": "career",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "V21"
      ]
    }
  },
  {
    "id": "student_career_kariyer_planlama",
    "officialLabel": "Kariyer Planlama",
    "audience": "student",
    "developmentArea": "career",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "V22"
      ]
    }
  },
  {
    "id": "student_social_emotional_madde_bagimliligini_onleme",
    "officialLabel": "Madde Bağımlılığını Önleme",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T27"
      ]
    }
  },
  {
   "id": "student_career_meslek_ile_ilgi_deger_yetenek_ve_kisisel_ozellik_iliskisi",
"officialLabel": "Meslek ile İlgi, Değer, Yetenek ve Kişisel Özellik İlişkisi",
    "audience": "student",
    "developmentArea": "career",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "V24"
      ]
    }
  },
  {
    "id": "student_career_meslek_sahibi_olmanin_onemi",
    "officialLabel": "Meslek Sahibi Olmanın Önemi",
    "audience": "student",
    "developmentArea": "career",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "V26"
      ]
    }
  },
  {
    "id": "student_career_meslek_secerken_dikkat_edilmesi_gereken_hususlar",
    "officialLabel": "Meslek Seçerken Dikkat Edilmesi Gereken Hususlar",
    "audience": "student",
    "developmentArea": "career",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "V27"
      ]
    }
  },
  {
    "id": "student_career_meslek_tanitimi",
    "officialLabel": "Meslek Tanıtımı",
    "audience": "student",
    "developmentArea": "career",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "V29"
      ]
    }
  },
  {
    "id": "student_career_mesleki_hedef_belirleme",
    "officialLabel": "Mesleki Hedef Belirleme",
    "audience": "student",
    "developmentArea": "career",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "V30"
      ]
    }
  },
  {
    "id": "student_academic_motivasyon",
    "officialLabel": "Motivasyon",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U17"
      ]
    }
  },
  {
    "id": "student_social_emotional_mukemmelliyetcilik",
    "officialLabel": "Mükemmelliyetçilik",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S35"
      ]
    }
  },
  {
    "id": "student_academic_okul_basarisini_artirma",
    "officialLabel": "Okul Başarısını Artırma",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U20"
      ]
    }
  },
  {
    "id": "student_academic_okul_kurallari",
    "officialLabel": "Okul Kuralları",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U19"
      ]
    }
  },
  {
    "id": "student_academic_okul_olgunlugu",
    "officialLabel": "Okul Olgunluğu",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U18"
      ]
    }
  },
  {
    "id": "student_academic_okul_ve_cevresindeki_egitim_olanaklari",
"officialLabel": "Okuldaki ve Okul Çevresindeki Eğitim Olanakları",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U25"
      ]
    }
  },
  {
    "id": "student_academic_okula_ve_cevreye_uyum",
    "officialLabel": "Okula ve Çevreye Uyum",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U21"
      ]
    }
  },
  {
    "id": "student_academic_okulda_secilebilecek_alan_dallar",
    "officialLabel": "Okulda Seçilebilecek Alan/Dallar",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U23"
      ]
    }
  },
  {
    "id": "student_academic_okullara_sinavlara_basvuru_kilavuzlari",
    "officialLabel": "Okullara/Sınavlara Başvuru Kılavuzları",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U27"
      ]
    }
  },
  {
    "id": "student_academic_okulun_fiziksel_imkanlari",
    "officialLabel": "Okulun Fiziksel İmkanları",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U22"
      ]
    }
  },
  {
    "id": "student_academic_okulun_sosyokulturel_imk_nlari",
"officialLabel": "Okulun Sosyokültürel İmkanları",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U29"
      ]
    }
  },
  {
    "id": "student_social_emotional_olumlu_davranis_gelistirme",
    "officialLabel": "Olumlu Davranış Geliştirme",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S36"
      ]
    }
  },
  {
    "id": "student_social_emotional_otokontrol",
    "officialLabel": "Otokontrol",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S37"
      ]
    }
  },
  {
    "id": "student_social_emotional_ofke_kontrolu",
    "officialLabel": "Öfke Yönetimi",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S42"
      ]
    }
  },
  {
    "id": "student_academic_ogrenciyi_ilgilendiren_yonetmelikler",
    "officialLabel": "Öğrenciyi İlgilendiren Yönetmelikler",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U31"
      ]
    }
  },
  {
    "id": "student_academic_ogrenme_stilleri",
    "officialLabel": "Öğrenme Stilleri",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U33"
      ]
    }
  },
  {
    "id": "student_social_emotional_oz_bakim_becerileri",
    "officialLabel": "Öz Bakım Becerileri",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S41"
      ]
    }
  },
  {
    "id": "student_academic_oz_disiplin_gelistirme",
    "officialLabel": "Öz Disiplin Geliştirme",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U34"
      ]
    }
  },
  {
    "id": "student_academic_oz_duzenlemeli_ogrenme",
    "officialLabel": "Öz Düzenlemeli Öğrenme",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U35"
      ]
    }
  },
  {
    "id": "student_social_emotional_oz_farkindaligi_gelistirme",
    "officialLabel": "Öz Farkındalığı Geliştirme",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S38"
      ]
    }
  },
  {
    "id": "student_career_ozgecmis_hazirlama",
    "officialLabel": "Özgeçmiş Hazırlama",
    "audience": "student",
    "developmentArea": "career",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "V31"
      ]
    }
  },
  {
    "id": "student_social_emotional_ozguven_gelistirme",
    "officialLabel": "Özgüven Geliştirme",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S39"
      ]
    }
  },
  {
    "id": "student_social_emotional_ozsaygi",
    "officialLabel": "Özsaygı Geliştirme",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "S40"
      ]
    }
  },
  {
    "id": "student_social_emotional_problem_cozme_becerileri",
    "officialLabel": "Problem Çözme Becerileri",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T8"
      ]
    }
  },
  {
    "id": "student_social_emotional_psikolojik_saglamlik",
    "officialLabel": "Psikolojik Sağlamlık",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T17"
      ]
    }
  },
  {
    "id": "student_social_emotional_psikolojik_saglamlik_programi",
    "officialLabel": "Psikolojik Sağlamlık Psikoeğitim Programı",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T18"
      ]
    }
  },
  {
    "id": "student_social_emotional_psikososyal_destek_cinsel_istismar",
    "officialLabel": "Psikososyal Destek-CİNSEL İSTİSMAR",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T9",
        "T10"
      ]
    }
  },
  {
    "id": "student_social_emotional_psikososyal_destek_dogal_afet",
    "officialLabel": "Psikososyal Destek-DOĞAL AFET",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T11"
      ]
    }
  },
  {
    "id": "student_social_emotional_psikososyal_destek_goc",
    "officialLabel": "Psikososyal Destek-GÖÇ",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T13"
      ]
    }
  },
  {
    "id": "student_social_emotional_psikososyal_destek_intihar",
    "officialLabel": "Psikososyal Destek-İNTİHAR",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T14"
      ]
    }
  },
  {
    "id": "student_social_emotional_psikososyal_destek_teror",
    "officialLabel": "Psikososyal Destek-TERÖR",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T15"
      ]
    }
  },
  {
    "id": "student_social_emotional_psikososyal_destek_yas",
    "officialLabel": "Psikososyal Destek-YAS",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T16"
      ]
    }
  },
  {
    "id": "student_academic_rehberlik_ve_psk_dan_ser_tan",
    "officialLabel": "Rehberlik ve Psikolojik Danışma Servisinin Tanıtılması",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U36"
      ]
    }
  },
  {
    "id": "student_social_emotional_saglikli_yasam",
    "officialLabel": "Sağlıklı Yaşam",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T29"
      ]
    }
  },
  {
    "id": "student_academic_serbest_zamani_degerlendirme",
    "officialLabel": "Serbest Zamanı Değerlendirme",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U37"
      ]
    }
  },
  {
    "id": "student_academic_sinav_kaygisi",
    "officialLabel": "Sınav Kaygısı",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U38"
      ]
    }
  },
  {
    "id": "student_academic_sinavda_basarili_olma_stratejileri",
    "officialLabel": "Sınavda Başarılı Olma Stratejileri",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U39"
      ]
    }
  },
  {
    "id": "student_academic_sinavlarda_basarili_olma_ve_calisma_yollari",
    "officialLabel": "Sınavlarda Başarılı Olma Ve Çalışma Yolları",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U41"
      ]
    }
  },
  {
    "id": "student_social_emotional_sinir_koyma",
    "officialLabel": "Sınır Koyma",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T19"
      ]
    }
  },
  {
    "id": "student_social_emotional_siber_zorbalik",
    "officialLabel": "Siber Zorbalık",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T20"
      ]
    }
  },
  {
    "id": "student_social_emotional_sosyal_beceriler",
    "officialLabel": "Sosyal Beceriler",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T21"
      ]
    }
  },
  {
    "id": "student_career_staj",
    "officialLabel": "Staj",
    "audience": "student",
    "developmentArea": "career",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "V32"
      ]
    }
  },
  {
    "id": "student_social_emotional_stresle_bas_etme_becerileri",
    "officialLabel": "Stresle Baş Etme Becerileri",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T22"
      ]
    }
  },
  {
    "id": "student_social_emotional_siddeti_onleme",
    "officialLabel": "Şiddeti Önleme",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T23"
      ]
    }
  },
  {
    "id": "student_social_emotional_teknoloji_bagimliligini_onleme",
    "officialLabel": "Teknoloji Bağımlılığını Önleme",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T31"
      ]
    }
  },
  {
    "id": "student_social_emotional_tutun_bagimliligini_onleme",
    "officialLabel": "Tütün Bağımlılığını Önleme",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T33"
      ]
    }
  },
  {
    "id": "student_academic_ust_ogr_kurum_tercih_edilebilecek_alan_dallar",
"officialLabel": "Üst Öğrenim Kurumlarında Tercih Edilebilecek Alan/Dallar",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U43"
      ]
    }
  },
  {
    "id": "student_academic_ust_ogrenim_kurumlarinin_tanitilmasi",
    "officialLabel": "Üst Öğrenim Kurumlarının Tanıtılması",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U45"
      ]
    }
  },
  {
    "id": "student_academic_ust_ogrenimde_yararlanilacak_burslar_ve_barinma_olanaklari",
    "officialLabel": "Üst Öğrenimde Yararlanılacak Burslar ve Barınma Olanakları",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U47"
      ]
    }
  },
  {
    "id": "student_academic_ust_ogrenime_gecis_sinavlari",
    "officialLabel": "Üst Öğrenime Geçiş Sınavları",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U49"
      ]
    }
  },
  {
    "id": "student_academic_verimli_ders_calisma_teknikleri",
    "officialLabel": "Verimli Ders Çalışma Teknikleri",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U50"
      ]
    }
  },
  {
    "id": "student_social_emotional_yaratici_dusunme_becerisi",
    "officialLabel": "Yaratıcı Düşünme Becerisi",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T34"
      ]
    }
  },
  {
    "id": "student_social_emotional_yardim_arama",
    "officialLabel": "Yardım Arama",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T36"
      ]
    }
  },
  {
    "id": "student_social_emotional_yasam_becerileri",
    "officialLabel": "Yaşam Becerileri",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T35"
      ]
    }
  },
  {
    "id": "student_social_emotional_yetersizligi_kabul",
    "officialLabel": "Yetersizliği Kabul",
    "audience": "student",
    "developmentArea": "social_emotional",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "T37"
      ]
    }
  },
  {
    "id": "student_academic_yurt_disi_egitim_olanaklari",
    "officialLabel": "Yurt Dışı Eğitim Olanakları",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U51"
      ]
    }
  },
  {
    "id": "student_academic_zaman_yonetimi",
    "officialLabel": "Zaman Yönetimi",
    "audience": "student",
    "developmentArea": "academic",
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "U52"
      ]
    }
  },
 {
  "id": "student_academic_zek_turleri_ve_ozellikleri",
  "officialLabel": "Zeka Türleri ve Özellikleri",
  "audience": "student",
  "developmentArea": "academic",
  "workMode": "group",
  "active": true,
  "source": {
    "system": "RPDH_SUNUM_SISTEMI",
    "version": "2020",
    "cells": [
      "U53"
    ]
  }
},

// =========================================================
// MEBBİS 2026-2027 — YENİ ÖĞRENCİ FAALİYETLERİ
// =========================================================

{
  "id": "student_social_emotional_bagimlilikla_mucadele_yasam_becerileri_egitimi_yybe",
  "officialLabel": "Bağımlılıkla Mücadele Yaşam Becerileri Eğitimi (YYBE)",
  "audience": "student",
  "developmentArea": "social_emotional",
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "student_social_emotional_cocuk_haklari_ve_cocuk_kiymeti",
  "officialLabel": "Çocuk Hakları ve Çocuk Kıymeti",
  "audience": "student",
  "developmentArea": "social_emotional",
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "student_social_emotional_hayat_boyu_ogrenme",
  "officialLabel": "Hayat Boyu Öğrenme",
  "audience": "student",
  "developmentArea": "social_emotional",
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "student_social_emotional_okulda_devamsizligin_onlenmesi_snt_ii",
  "officialLabel": "Okulda Devamsızlığın Önlenmesi (SNT II)",
  "audience": "student",
  "developmentArea": "social_emotional",
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "student_social_emotional_selamlasma",
  "officialLabel": "Selamlaşma",
  "audience": "student",
  "developmentArea": "social_emotional",
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "student_social_emotional_sosyal_uyum",
  "officialLabel": "Sosyal Uyum",
  "audience": "student",
  "developmentArea": "social_emotional",
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "student_social_emotional_toplumsal_uyum_becerileri",
  "officialLabel": "Toplumsal Uyum Becerileri",
  "audience": "student",
  "developmentArea": "social_emotional",
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "student_career_mesleki_benlik",
  "officialLabel": "Mesleki Benlik",
  "audience": "student",
  "developmentArea": "career",
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},

{
  "id": "parent_support_tbm_alkol_bagimliligi",
    "officialLabel": "(TBM) Alkol Bağımlılığı",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA44"
      ]
    }
  },
  {
    "id": "parent_support_tbm_kumar_bagimliligi",
    "officialLabel": "(TBM) Kumar Bağımlılığı",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "E_REHBERLIK_GUIDE",
      "version": "2025-2026",
      "printedPage": 18
    }
  },
  {
    "id": "parent_support_tbm_madde_bagimliligi",
    "officialLabel": "(TBM) Madde Bağımlılığı",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA46"
      ]
    }
  },
  {
    "id": "parent_support_tbm_saglikli_yasam",
    "officialLabel": "(TBM) Sağlıklı Yaşam",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA48"
      ]
    }
  },
  {
    "id": "parent_support_tbm_teknoloji_bagimliligi",
    "officialLabel": "(TBM) Teknoloji Bağımlılığı",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA50"
      ]
    }
  },
  {
    "id": "parent_support_tbm_tutun_bagimliligi",
    "officialLabel": "(TBM) Tütün Bağımlılığı",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA52"
      ]
    }
  },
  {
    "id": "parent_support_aile_ici_iletisim",
    "officialLabel": "Aile İçi İletişim",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z8"
      ]
    }
  },
  {
    "id": "parent_support_akademik_ozyeterlik",
    "officialLabel": "Akademik Özyeterlik",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z9"
      ]
    }
  },
  {
    "id": "parent_support_akran_arabuluculugu",
    "officialLabel": "Akran Arabuluculuğu",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z10"
      ]
    }
  },
 {
  "id": "parent_support_akran_zorbaligi",
  "officialLabel": "Akran Nezaketi",
  "audience": "parent",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
  {
    "id": "parent_support_alan_dal_tanitimi_ve_secimi",
    "officialLabel": "Alan/Dal Tanıtımı ve Seçimi",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z12"
      ]
    }
  },
  {
    "id": "parent_support_alkol_bagimliligini_onleme",
    "officialLabel": "Alkol Bağımlılığını Önleme",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA45"
      ]
    }
  },
  {
    "id": "parent_support_anne_baba_tutumlari",
    "officialLabel": "Anne Baba Tutumları",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z13"
      ]
    }
  },
  {
    "id": "parent_support_atilganlik",
    "officialLabel": "Atılganlık",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z14"
      ]
    }
  },
  {
    "id": "parent_support_baba_destek_programi",
    "officialLabel": "Baba Destek Programı",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z15"
      ]
    }
  },
  {
    "id": "parent_support_bilincli_teknoloji_kullanimi",
    "officialLabel": "Bilinçli Teknoloji Kullanımı",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z16"
      ]
    }
  },
  {
    "id": "parent_support_bireysel_farkliliklara_saygi",
    "officialLabel": "Bireysel Farklılıklara Saygı",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z17"
      ]
    }
  },
  {
    "id": "parent_support_catisma_cozme_becerileri",
    "officialLabel": "Çatışma Çözme Becerileri",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z18"
      ]
    }
  },
  {
    "id": "parent_support_cevredeki_is_olanaklari_ve_calisma_kosullari",
    "officialLabel": "Çevredeki İş Olanakları ve Çalışma Koşulları",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z19"
      ]
    }
  },
  {
    "id": "parent_support_cocuk_hak_ve_sorumluluklari",
    "officialLabel": "Çocuk Hakları ve Çocuk Kıymeti",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z23"
      ]
    }
  },
  {
    "id": "parent_support_cocuk_ve_ergenlerin_gelisim_donemleri",
"officialLabel": "Çocuk ve Ergen Gelişim Dönemleri",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z21"
      ]
    }
  },
  {
    "id": "parent_support_cocuklar_ve_oyun",
    "officialLabel": "Çocuklar ve Oyun",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z24"
      ]
    }
  },
  {
    "id": "parent_support_cocuklarda_cinsel_egitim",
    "officialLabel": "Çocuklarda Cinsel Eğitim",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z25"
      ]
    }
  },
  {
    "id": "parent_support_cocuklarda_oz_disiplin_gelistirme",
    "officialLabel": "Çocuklarda Öz Disiplin Geliştirme",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z26"
      ]
    }
  },
  {
    "id": "parent_support_davranis_sorunlari",
    "officialLabel": "Davranış Sorunları",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z28"
      ]
    }
  },
  {
    "id": "parent_support_degisen_ben_veli_destek_prg",
    "officialLabel": "Değişen Ben-Veli Destek Programı",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z32"
      ]
    }
  },
  {
    "id": "parent_support_degisen_yasam_kosullarina_uyum",
    "officialLabel": "Değişen Yaşam Koşullarına Uyum",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z31"
      ]
    }
  },
  {
    "id": "parent_support_ders_secimi",
    "officialLabel": "Ders Seçimi",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z29"
      ]
    }
  },
  {
    "id": "parent_support_devamsizligi_onleme",
    "officialLabel": "Devamsızlığı Önleme",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z30"
      ]
    }
  },
  {
    "id": "parent_support_dikkat_gelistirme_calismalari",
    "officialLabel": "Dikkat Geliştirme Çalışmaları",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z35"
      ]
    }
  },
  {
    "id": "parent_support_duygu_duzenleme",
    "officialLabel": "Duygu Düzenleme",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z33"
      ]
    }
  },
  {
    "id": "parent_support_duygu_farkindaligi",
    "officialLabel": "Duygu Farkındalığı",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z34"
      ]
    }
  },
  {
    "id": "parent_support_e_kpss",
    "officialLabel": "E-KPSS",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z41"
      ]
    }
  },
  {
    "id": "parent_support_ebeveynlik_becerileri",
    "officialLabel": "Ebeveynlik Becerileri",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z36"
      ]
    }
  },
  {
    "id": "parent_support_elestiriye_tolerans_gosterme",
    "officialLabel": "Eleştiriye Tolerans Gösterme",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z37"
      ]
    }
  },
  {
    "id": "parent_support_engel_turleri_ve_tanilama_surecleri",
    "officialLabel": "Engel Türleri ve Tanılama Süreçleri",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z38",
        "Z39"
      ]
    }
  },
  {
    "id": "parent_support_etik_davranis",
    "officialLabel": "Etik Davranış",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z40"
      ]
    }
  },
  {
    "id": "parent_support_girisimcilik",
    "officialLabel": "Girişimcilik",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z42"
      ]
    }
  },
  {
    "id": "parent_support_hedef_belirleme",
    "officialLabel": "Hedef Belirleme",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z43"
      ]
    }
  },
  {
    "id": "parent_support_ihmal_istismardan_korunma",
    "officialLabel": "İhmal ve İstismar Farkındalığı",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z44"
      ]
    }
  },
  {
    "id": "parent_support_iletisim_becerileri",
    "officialLabel": "İletişim Becerileri",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z45"
      ]
    }
  },
  {
    "id": "parent_support_is_yasamina_yonelik_beceriler",
    "officialLabel": "İş Yaşamına Yönelik Beceriler",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z46"
      ]
    }
  },
  {
    "id": "parent_support_isbirligi_gelistirme",
    "officialLabel": "İşbirliği Geliştirme",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z47"
      ]
    }
  },
  {
    "id": "parent_support_kadina_yonelik_siddetin_onlenmesi",
    "officialLabel": "Kadına Yönelik Şiddetin Önlenmesi",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z48",
        "Z49"
      ]
    }
  },
  {
    "id": "parent_support_kalfalik_ve_ustalik_sistemleri_hakkinda_bilgilendirme",
    "officialLabel": "Kalfalık ve Ustalık Sistemleri Hakkında Bilgilendirme",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z52"
      ]
    }
  },
  {
    "id": "parent_support_karar_verme_becerisi",
    "officialLabel": "Karar Verme Becerisi",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z50"
      ]
    }
  },
  {
    "id": "parent_support_kariyer_planlama",
    "officialLabel": "Kariyer Planlama",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z51"
      ]
    }
  },
  {
    "id": "parent_support_kusaklararasi_iletisim",
    "officialLabel": "Kuşaklararası İletişim",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z54"
      ]
    }
  },
  {
    "id": "parent_support_madde_bagimliligini_onleme",
    "officialLabel": "Madde Bağımlılığını Önleme",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA47"
      ]
    }
  },
  {
    "id": "parent_support_meslek_ile_ilgi_deger_yetenek_ve_kisisel_ozellik_iliskisi",
"officialLabel": "Meslek ile İlgi, Değer, Yetenek ve Kişisel Özellik İlişkisi",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z55",
        "Z56"
      ]
    }
  },
  {
    "id": "parent_support_meslek_sahibi_olmanin_onemi",
    "officialLabel": "Meslek Sahibi Olmanın Önemi",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z57"
      ]
    }
  },
  {
    "id": "parent_support_meslek_secerken_dikkat_edilmesi_gereken_hususlar",
    "officialLabel": "Meslek Seçerken Dikkat Edilmesi Gereken Hususlar",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z59"
      ]
    }
  },
  {
    "id": "parent_support_meslek_tanitimi",
    "officialLabel": "Meslek Tanıtımı",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z58"
      ]
    }
  },
  {
    "id": "parent_support_motivasyon",
    "officialLabel": "Motivasyon",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z61"
      ]
    }
  },
  {
    "id": "parent_support_mukemmelliyetcilik",
    "officialLabel": "Mükemmelliyetçilik",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z62"
      ]
    }
  },
  {
    "id": "parent_support_okul_basarisinda_ailenin_rolu",
    "officialLabel": "Okul Başarısında Ailenin Rolü",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "Z63"
      ]
    }
  },
  {
    "id": "parent_support_okul_kurallari",
    "officialLabel": "Okul Kuralları",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA9"
      ]
    }
  },
  {
    "id": "parent_support_okul_olgunlugu",
    "officialLabel": "Okul Olgunluğu",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA8"
      ]
    }
  },
  {
    "id": "parent_support_okula_uyum_calismalari",
    "officialLabel": "Okula Uyum Çalışmaları",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA10"
      ]
    }
  },
  {
    "id": "parent_support_olumlu_davranis_gelistirme",
    "officialLabel": "Olumlu Davranış Geliştirme",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA11"
      ]
    }
  },
  {
    "id": "parent_support_otokontrol",
    "officialLabel": "Otokontrol",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA12"
      ]
    }
  },
  {
    "id": "parent_support_ofke_yonetimi",
    "officialLabel": "Öfke Yönetimi",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA13"
      ]
    }
  },
  {
    "id": "parent_support_ogrenciyi_ilgilendiren_yonetmelikler",
    "officialLabel": "Öğrenciyi İlgilendiren Yönetmelikler",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA14",
        "AA15"
      ]
    }
  },
  {
    "id": "parent_support_ogrenme_stilleri",
    "officialLabel": "Öğrenme Stilleri",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA16"
      ]
    }
  },
  {
    "id": "parent_support_oz_bakim_becerileri",
    "officialLabel": "Öz Bakım Becerileri",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA17"
      ]
    }
  },
  {
    "id": "parent_support_oz_duzenlemeli_ogrenme",
    "officialLabel": "Öz Düzenlemeli Öğrenme",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA24"
      ]
    }
  },
  {
    "id": "parent_support_oz_farkindaligi_gelistirme",
    "officialLabel": "Öz Farkındalığı Geliştirme",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA25"
      ]
    }
  },
  {
    "id": "parent_support_ozel_egitim_gereksinimli_ogrencilerin_egt_olanaklari",
    "officialLabel": "Özel Eğitim Gereksinimli Öğrencilerin Eğitim Olanakları",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA18",
        "AA19"
      ]
    }
  },
  {
    "id": "parent_support_ozel_egitim_gereksinimli_ogrencilerin_gel_ozellikleri",
    "officialLabel": "Özel Eğitim Gereksinimli Öğrencilerin Gelişim Özellikleri",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA20",
        "AA21"
      ]
    }
  },
  {
    "id": "parent_support_ozguven_gelistirme",
    "officialLabel": "Özgüven Geliştirme",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA22"
      ]
    }
  },
  {
    "id": "parent_support_ozsaygi_gelistirme",
    "officialLabel": "Özsaygı Geliştirme",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA23"
      ]
    }
  },
  {
    "id": "parent_support_problem_cozme_becerileri",
    "officialLabel": "Problem Çözme Becerileri",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA26"
      ]
    }
  },
  {
    "id": "parent_support_psikolojik_saglamlik",
    "officialLabel": "Psikolojik Sağlamlık",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA27"
      ]
    }
  },
  {
    "id": "parent_support_psikososyal_destek_cinsel_istismar",
    "officialLabel": "Psikososyal Destek-CİNSEL İSTİSMAR",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA28"
      ]
    }
  },
  {
    "id": "parent_support_psikososyal_destek_dogal_afet",
    "officialLabel": "Psikososyal Destek-DOĞAL AFET",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA30"
      ]
    }
  },
  {
    "id": "parent_support_psikososyal_destek_goc",
    "officialLabel": "Psikososyal Destek-GÖÇ",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA32"
      ]
    }
  },
  {
    "id": "parent_support_psikososyal_destek_intihar",
    "officialLabel": "Psikososyal Destek-İNTİHAR",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA33"
      ]
    }
  },
  {
    "id": "parent_support_psikososyal_destek_teror",
    "officialLabel": "Psikososyal Destek-TERÖR",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA34"
      ]
    }
  },
  {
    "id": "parent_support_psikososyal_destek_yas",
    "officialLabel": "Psikososyal Destek-YAS",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA35"
      ]
    }
  },
  {
    "id": "parent_support_rehberlik_ve_psk_danisma_servisinin_tanitilmasi",
    "officialLabel": "Rehberlik ve Psikolojik Danışma Servisinin Tanıtılması",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA36"
      ]
    }
  },
  {
    "id": "parent_support_saglikli_yasam",
    "officialLabel": "Sağlıklı Yaşam",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA49"
      ]
    }
  },
  {
    "id": "parent_support_serbest_zamani_degerlendirme",
    "officialLabel": "Serbest Zamanı Değerlendirme",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA38"
      ]
    }
  },
  {
    "id": "parent_support_sinav_kaygisi",
    "officialLabel": "Sınav Kaygısı",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA39"
      ]
    }
  },
  {
    "id": "parent_support_sinir_koyma",
    "officialLabel": "Sınır Koyma",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA40"
      ]
    }
  },
  {
    "id": "parent_support_sosyal_beceriler",
    "officialLabel": "Sosyal Beceriler",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA42"
      ]
    }
  },
  {
    "id": "parent_support_stres_yonetimi",
    "officialLabel": "Stres Yönetimi",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA41"
      ]
    }
  },
  {
    "id": "parent_support_siddetin_onlenmesi",
    "officialLabel": "Şiddetin Önlenmesi",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA43"
      ]
    }
  },
  {
    "id": "parent_support_tek_ebeveynlik",
    "officialLabel": "Tek Ebeveynlik",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA54"
      ]
    }
  },
  {
    "id": "parent_support_teknoloji_bag_onleme",
"officialLabel": "Teknoloji Bağımlılığını Önleme",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA51"
      ]
    }
  },
  {
    "id": "parent_support_toplumsal_uyum_becerileri",
    "officialLabel": "Toplumsal Uyum Becerileri",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA55"
      ]
    }
  },
  {
    "id": "parent_support_tutun_bagimliligini_onleme",
    "officialLabel": "Tütün Bağımlılığını Önleme",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA53"
      ]
    }
  },
  {
    "id": "parent_support_ust_ogrenim_kurumlari",
    "officialLabel": "Üst Öğrenim Kurumları",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA56"
      ]
    }
  },
  {
    "id": "parent_support_ust_ogrenime_gecis_sinavlari",
    "officialLabel": "Üst Öğrenime Geçiş Sınavları",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA57"
      ]
    }
  },
  {
    "id": "parent_support_verimli_ders_calisma_teknikleri",
    "officialLabel": "Verimli Ders Çalışma Teknikleri",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA58"
      ]
    }
  },
  {
    "id": "parent_support_yaraticilik",
    "officialLabel": "Yaratıcılık",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA60"
      ]
    }
  },
  {
    "id": "parent_support_yardim_arama",
    "officialLabel": "Yardım Arama",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA59"
      ]
    }
  },
  {
    "id": "parent_support_yasam_becerileri",
    "officialLabel": "Yaşam Becerileri",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA61"
      ]
    }
  },
  {
    "id": "parent_support_yetersizligi_kabul",
    "officialLabel": "Yetersizliği Kabul",
    "audience": "parent",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AA62"
      ]
    }
  },
  {
  "id": "parent_support_zaman_yonetimi",
  "officialLabel": "Zaman Yönetimi",
  "audience": "parent",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "RPDH_SUNUM_SISTEMI",
    "version": "2020",
    "cells": [
      "AA63"
    ]
  }
},

// =========================================================
// MEBBİS 2026-2027 — YENİ VELİ MÜŞAVİRLİK FAALİYETLERİ
// =========================================================

{
  "id": "parent_support_ailelere_yonelik_bagimlilikla_mucadele_psikoegitim_programi",
  "officialLabel": "Ailelere Yönelik Bağımlılıkla Mücadele Psikoeğitim Programı",
  "audience": "parent",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "parent_support_bilsem_tanitimi",
  "officialLabel": "BİLSEM Tanıtımı",
  "audience": "parent",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "parent_support_gelecegi_planlama",
  "officialLabel": "Geleceği Planlama",
  "audience": "parent",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "parent_support_kariyer_farkindaligi_aile_egitim_programi",
  "officialLabel": "Kariyer Farkındalığı Aile Eğitim Programı",
  "audience": "parent",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "parent_support_kariyer_gelisimi",
  "officialLabel": "Kariyer Gelişimi",
  "audience": "parent",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "parent_support_mesleki_benlik",
  "officialLabel": "Mesleki Benlik",
  "audience": "parent",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "parent_support_okulda_devamsizligin_onlenmesi_snt_ii",
  "officialLabel": "Okulda Devamsızlığın Önlenmesi (SNT II)",
  "audience": "parent",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "parent_support_okulda_secilebilecek_alan_ve_dallar",
  "officialLabel": "Okulda Seçilebilecek Alan ve Dallar",
  "audience": "parent",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "parent_support_selamlasma",
  "officialLabel": "Selamlaşma",
  "audience": "parent",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "parent_support_siber_zorbalik",
  "officialLabel": "Siber Zorbalık",
  "audience": "parent",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "parent_support_sosyal_uyum",
  "officialLabel": "Sosyal Uyum",
  "audience": "parent",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},

{
  "id": "teacher_support_tbm_alkol_bagimliligi",
    "officialLabel": "(TBM) Alkol Bağımlılığı",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC44"
      ]
    }
  },
  {
    "id": "teacher_support_tbm_kumar_bagimliligi",
    "officialLabel": "(TBM) Kumar Bağımlılığı",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "E_REHBERLIK_GUIDE",
      "version": "2025-2026",
      "printedPage": 20
    }
  },
  {
    "id": "teacher_support_tbm_madde_bagimliligi",
    "officialLabel": "(TBM) Madde Bağımlılığı",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC46"
      ]
    }
  },
  {
    "id": "teacher_support_tbm_saglikli_yasam",
    "officialLabel": "(TBM) Sağlıklı Yaşam",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC48"
      ]
    }
  },
  {
    "id": "teacher_support_tbm_teknoloji_bagimliligi",
    "officialLabel": "(TBM) Teknoloji Bağımlılığı",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC50"
      ]
    }
  },
  {
    "id": "teacher_support_tbm_tutun_bagimliligi",
    "officialLabel": "(TBM) Tütün Bağımlılığı",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC52"
      ]
    }
  },
  {
    "id": "teacher_support_akademik_ozyeterlik",
    "officialLabel": "Akademik Özyeterlik",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB8"
      ]
    }
  },
  {
    "id": "teacher_support_akran_arabuluculugu",
    "officialLabel": "Akran Arabuluculuğu",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB9"
      ]
    }
  },
  {
  "id": "teacher_support_akran_zorbaligi",
  "officialLabel": "Akran Nezaketi",
  "audience": "teacher",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
  {
    "id": "teacher_support_alkol_bagimliligini_onleme",
    "officialLabel": "Alkol Bağımlılığını Önleme",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC45"
      ]
    }
  },
  {
    "id": "teacher_support_anne_baba_tutumlari",
    "officialLabel": "Anne Baba Tutumları",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB11"
      ]
    }
  },
  {
    "id": "teacher_support_atilganlik",
    "officialLabel": "Atılganlık",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB12"
      ]
    }
  },
  {
    "id": "teacher_support_bep_hazirlama",
    "officialLabel": "BEP Hazırlama",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB13"
      ]
    }
  },
  {
    "id": "teacher_support_bilgilendirme",
    "officialLabel": "Bilgilendirme",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC33"
      ]
    }
  },
  {
    "id": "teacher_support_bilincli_teknoloji_kullanimi",
    "officialLabel": "Bilinçli Teknoloji Kullanımı",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB14"
      ]
    }
  },
  {
    "id": "teacher_support_bilsem_tanitimi",
    "officialLabel": "BİLSEM Tanıtımı",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB15"
      ]
    }
  },
  {
    "id": "teacher_support_bireyi_tanima_teknikleri",
    "officialLabel": "Bireyi Tanıma Teknikleri",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB16"
      ]
    }
  },
  {
    "id": "teacher_support_bireysel_farkliliklara_saygi",
    "officialLabel": "Bireysel Farklılıklara Saygı",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB17"
      ]
    }
  },
  {
    "id": "teacher_support_catisma_cozme_becerileri",
    "officialLabel": "Çatışma Çözme Becerileri",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB18"
      ]
    }
  },
  {
    "id": "teacher_support_cocuk_hak_ve_sorumluluklari",
    "officialLabel": "Çocuk Hakları ve Çocuk Kıymeti",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB19"
      ]
    }
  },
  {
    "id": "teacher_support_cocuk_ve_ergenlerin_gelisim_ozellikleri",
    "officialLabel": "Çocuk ve Ergenlerin Gelişim Özellikleri",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB20",
        "AB21"
      ]
    }
  },
  {
    "id": "teacher_support_cocuklar_ve_oyun",
    "officialLabel": "Çocuklar ve Oyun",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB22"
      ]
    }
  },
  {
    "id": "teacher_support_cocuklarda_cinsel_egitim",
    "officialLabel": "Çocuklarda Cinsel Eğitim",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB23"
      ]
    }
  },
  {
    "id": "teacher_support_davranis_degistirme_teknikleri",
    "officialLabel": "Davranış Değiştirme Teknikleri",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB24"
      ]
    }
  },
  {
    "id": "teacher_support_degisen_ben_ogretmen_des_prg",
    "officialLabel": "Değişen Ben-Öğretmen Destek Programı",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB27"
      ]
    }
  },
  {
    "id": "teacher_support_degisen_yasam_kosullarina_uyum",
    "officialLabel": "Değişen Yaşam Koşullarına Uyum",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB26"
      ]
    }
  },
  {
    "id": "teacher_support_destek_egitim_odasi_hizmetleri",
    "officialLabel": "Destek Eğitim Odası Hizmetleri",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB25"
      ]
    }
  },
  {
    "id": "teacher_support_devamsizligi_onleme",
    "officialLabel": "Devamsızlığı Önleme",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB28"
      ]
    }
  },
  {
    "id": "teacher_support_dikkat_gelistirme_calismalari",
    "officialLabel": "Dikkat Geliştirme Çalışmaları",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB29"
      ]
    }
  },
  {
    "id": "teacher_support_duygu_duzenleme",
    "officialLabel": "Duygu Düzenleme",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB30"
      ]
    }
  },
  {
    "id": "teacher_support_duygu_farkindaligi",
    "officialLabel": "Duygu Farkındalığı",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB31"
      ]
    }
  },
  {
    "id": "teacher_support_e_kpss",
    "officialLabel": "E-KPSS",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB32"
      ]
    }
  },
  {
    "id": "teacher_support_elestiriye_tolerans_gosterme",
    "officialLabel": "Eleştiriye Tolerans Gösterme",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB33"
      ]
    }
  },
  {
    "id": "teacher_support_engel_turleri_ve_tanilama_surecleri",
    "officialLabel": "Engel Türleri ve Tanılama Süreçleri",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB35",
        "AB36"
      ]
    }
  },
  {
    "id": "teacher_support_etik_davranis",
    "officialLabel": "Etik Davranış",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB34"
      ]
    }
  },
  {
    "id": "teacher_support_gelecegi_planlama",
    "officialLabel": "Geleceği Planlama",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB37"
      ]
    }
  },
  {
    "id": "teacher_support_gelisim_donemi_ozellikleri",
    "officialLabel": "Gelişim Dönemi Özellikleri",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB38"
      ]
    }
  },
  {
    "id": "teacher_support_geri_bildirim_verme",
    "officialLabel": "Geri Bildirim Verme",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC35"
      ]
    }
  },
  {
    "id": "teacher_support_girisimcilik",
    "officialLabel": "Girişimcilik",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB39"
      ]
    }
  },
  {
    "id": "teacher_support_hedef_belirleme",
    "officialLabel": "Hedef Belirleme",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB40"
      ]
    }
  },
  {
    "id": "teacher_support_ihmal_istismardan_korunma",
    "officialLabel": "İhmal ve İstismar Farkındalığı",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB41"
      ]
    }
  },
  {
    "id": "teacher_support_iletisim_becerileri",
    "officialLabel": "İletişim Becerileri",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB42"
      ]
    }
  },
  {
    "id": "teacher_support_is_ve_meslek_etigi",
    "officialLabel": "İş ve Meslek Etiği",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB45"
      ]
    }
  },
  {
    "id": "teacher_support_is_yasamina_yonelik_beceriler",
    "officialLabel": "İş Yaşamına Yönelik Beceriler",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB43"
      ]
    }
  },
  {
    "id": "teacher_support_isbirligi_gelistirme",
    "officialLabel": "İşbirliği Geliştirme",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB44"
      ]
    }
  },
  {
    "id": "teacher_support_kadina_yonelik_siddetin_onlenmesi",
    "officialLabel": "Kadına Yönelik Şiddetin Önlenmesi",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB46"
      ]
    }
  },
  {
    "id": "teacher_support_kalfalik_ve_ustalik_sistemleri_hakkinda_bilgilendirme",
    "officialLabel": "Kalfalık ve Ustalık Sistemleri Hakkında Bilgilendirme",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB49"
      ]
    }
  },
  {
    "id": "teacher_support_karar_verme_becerisi",
    "officialLabel": "Karar Verme Becerisi",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB48"
      ]
    }
  },
  {
    "id": "teacher_support_kariyer_gelisimi",
    "officialLabel": "Kariyer Gelişimi",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB51"
      ]
    }
  },
  {
    "id": "teacher_support_kariyer_planlama",
    "officialLabel": "Kariyer Planlama",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB52"
      ]
    }
  },
  {
    "id": "teacher_support_kusaklararasi_iletisim",
    "officialLabel": "Kuşaklararası İletişim",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB53"
      ]
    }
  },
  {
    "id": "teacher_support_madde_bagimliligini_onleme",
    "officialLabel": "Madde Bağımlılığını Önleme",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC47"
      ]
    }
  },
  {
    "id": "teacher_support_meslek_ile_ilgi_deger_yetenek_ve_kisisel_ozellik_iliskisi",
"officialLabel": "Meslekle İlgi,Yetenek, Değer ve Kişisel Özellik İlişkisi",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB54"
      ]
    }
  },
  {
    "id": "teacher_support_motivasyon",
    "officialLabel": "Motivasyon",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB56"
      ]
    }
  },
  {
    "id": "teacher_support_mukemmelliyetcilik",
    "officialLabel": "Mükemmelliyetçilik",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB57"
      ]
    }
  },
  {
    "id": "teacher_support_okul_basarisini_artirma",
    "officialLabel": "Okul Başarısını Artırma",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB58"
      ]
    }
  },
  {
    "id": "teacher_support_okul_olgunlugu",
    "officialLabel": "Okul Olgunluğu",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB59"
      ]
    }
  },
  {
    "id": "teacher_support_okula_ve_cevreye_uyum",
    "officialLabel": "Okula ve Çevreye Uyum",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB60"
      ]
    }
  },
  {
    "id": "teacher_support_okulda_secilecek_alan_dallar",
    "officialLabel": "Okulda Seçilecek Alan/Dallar",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB61"
      ]
    }
  },
  {
    "id": "teacher_support_olumlu_davranis_gelistirme",
    "officialLabel": "Olumlu Davranış Geliştirme",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB62"
      ]
    }
  },
  {
    "id": "teacher_support_otokontrol",
    "officialLabel": "Otokontrol",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB63"
      ]
    }
  },
  {
    "id": "teacher_support_ofke_yonetimi",
    "officialLabel": "Öfke Yönetimi",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB64"
      ]
    }
  },
  {
    "id": "teacher_support_ogrenme_stilleri",
    "officialLabel": "Öğrenme Stilleri",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AB65"
      ]
    }
  },
  {
    "id": "teacher_support_ogretmen_grubuyla_vaka_paylasimi",
    "officialLabel": "Öğretmen Grubuyla Vaka Paylaşımı",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC8"
      ]
    }
  },
  {
    "id": "teacher_support_oz_disiplin_gelistirme",
    "officialLabel": "Öz Disiplin Geliştirme",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC14"
      ]
    }
  },
  {
    "id": "teacher_support_oz_duzenlemeli_ogrenme",
    "officialLabel": "Öz Düzenlemeli Öğrenme",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC15"
      ]
    }
  },
  {
    "id": "teacher_support_oz_farkindaligi_gelistirme",
    "officialLabel": "Öz Farkındalığı Geliştirme",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC16"
      ]
    }
  },
  {
    "id": "teacher_support_ozel_egitim_gereksinimli_ogrencilerin_egitim_olanaklari",
    "officialLabel": "Özel Eğitim Gereksinimli Öğrencilerin Eğitim Olanakları",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC10",
        "AC11"
      ]
    }
  },
  {
    "id": "teacher_support_ozel_egitim_gereksinimli_ogrencilerin_gelisim_ozellikleri",
    "officialLabel": "Özel Eğitim Gereksinimli Öğrencilerin Gelişim Özellikleri",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC12",
        "AC13"
      ]
    }
  },
  {
    "id": "teacher_support_ozguven_gelistirme",
    "officialLabel": "Özgüven Geliştirme",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC17"
      ]
    }
  },
  {
    "id": "teacher_support_ozsaygi_gelistirme",
    "officialLabel": "Özsaygı Geliştirme",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC18"
      ]
    }
  },
  {
    "id": "teacher_support_problem_cozme_becerileri",
    "officialLabel": "Problem Çözme Becerileri",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC19"
      ]
    }
  },
  {
    "id": "teacher_support_psikolojik_saglamlik",
    "officialLabel": "Psikolojik Sağlamlık",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC20"
      ]
    }
  },
  {
    "id": "teacher_support_psikososyal_destek_cinsel_istismar",
    "officialLabel": "Psikososyal Destek-CİNSEL İSTİSMAR",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC21",
        "AC22"
      ]
    }
  },
  {
    "id": "teacher_support_psikososyal_destek_dogal_afet",
    "officialLabel": "Psikososyal Destek-DOĞAL AFET",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC23",
        "AC24"
      ]
    }
  },
  {
    "id": "teacher_support_psikososyal_destek_goc",
    "officialLabel": "Psikososyal Destek-GÖÇ",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC25"
      ]
    }
  },
  {
    "id": "teacher_support_psikososyal_destek_intihar",
    "officialLabel": "Psikososyal Destek-İNTİHAR",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC26"
      ]
    }
  },
  {
    "id": "teacher_support_psikososyal_destek_teror",
    "officialLabel": "Psikososyal Destek-TERÖR",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC27"
      ]
    }
  },
  {
    "id": "teacher_support_psikososyal_destek_yas",
    "officialLabel": "Psikososyal Destek-YAS",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC28"
      ]
    }
  },
  {
  "id": "teacher_support_ram_okul_rpd_programi",
  "officialLabel": "RAM- Okul RPD Programı Bilgilendirme",
  "audience": "teacher",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "teacher_support_ram_okul_rpd_programi_geri_bildirim_verme",
  "officialLabel": "RAM- Okul RPD Programı Geri Bildirim Verme",
  "audience": "teacher",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
  {
    "id": "teacher_support_ram_okul_ziyaretleri",
    "officialLabel": "RAM-Okul Ziyaretleri",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC31"
      ]
    }
  },
  {
    "id": "teacher_support_rehberlik_ve_psk_danisma_servisinin_tanitilmasi",
    "officialLabel": "Rehberlik ve Psikolojik Danışma Servisinin Tanıtılması",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC29",
        "AC30"
      ]
    }
  },
  {
    "id": "teacher_support_saglikli_yasam",
    "officialLabel": "Sağlıklı Yaşam",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC49"
      ]
    }
  },
  {
    "id": "teacher_support_serbest_zamani_degerlendirme",
    "officialLabel": "Serbest Zamanı Değerlendirme",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC36"
      ]
    }
  },
  {
    "id": "teacher_support_sinav_kaygisi",
    "officialLabel": "Sınav Kaygısı",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC37"
      ]
    }
  },
  {
    "id": "teacher_support_sinif_rehberlik_programi",
    "officialLabel": "Sınıf Rehberlik Programı",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC38"
      ]
    }
  },
  {
    "id": "teacher_support_sinif_yonetimi",
    "officialLabel": "Sınıf Yönetimi",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC39"
      ]
    }
  },
  {
    "id": "teacher_support_sinir_koyma",
    "officialLabel": "Sınır Koyma",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC40"
      ]
    }
  },
  {
    "id": "teacher_support_sosyal_beceriler",
    "officialLabel": "Sosyal Beceriler",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC42"
      ]
    }
  },
  {
    "id": "teacher_support_stres_yonetimi",
    "officialLabel": "Stres Yönetimi",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC41"
      ]
    }
  },
  {
    "id": "teacher_support_siddetin_onlenmesi",
    "officialLabel": "Şiddetin Önlenmesi",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC43"
      ]
    }
  },
  {
    "id": "teacher_support_tek_ebeveynlik",
    "officialLabel": "Tek Ebeveynlik",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC54"
      ]
    }
  },
  {
    "id": "teacher_support_teknoloji_bagimliligini_onleme",
    "officialLabel": "Teknoloji Bağımlılığını Önleme",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC51"
      ]
    }
  },
  {
    "id": "teacher_support_toplumsal_uyum_becerileri",
    "officialLabel": "Toplumsal Uyum Becerileri",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC55"
      ]
    }
  },
  {
    "id": "teacher_support_tutun_bagimliligini_onleme",
    "officialLabel": "Tütün Bağımlılığını Önleme",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC53"
      ]
    }
  },
  {
    "id": "teacher_support_ust_ogrenim_kurumlari",
    "officialLabel": "Üst Öğrenim Kurumları",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC56"
      ]
    }
  },
  {
    "id": "teacher_support_ust_ogrenime_gecis_sinavlari",
    "officialLabel": "Üst Öğrenime Geçiş Sınavları",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC57"
      ]
    }
  },
  {
    "id": "teacher_support_verimli_ders_calisma_teknikleri",
    "officialLabel": "Verimli Ders Çalışma Teknikleri",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC58"
      ]
    }
  },
  {
    "id": "teacher_support_yaraticilik",
    "officialLabel": "Yaratıcılık",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC59"
      ]
    }
  },
  {
    "id": "teacher_support_yardim_arama",
    "officialLabel": "Yardım Arama",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC60"
      ]
    }
  },
  {
    "id": "teacher_support_yasam_becerileri",
    "officialLabel": "Yaşam Becerileri",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC61"
      ]
    }
  },
  {
    "id": "teacher_support_yetersizligi_kabul",
    "officialLabel": "Yetersizliği Kabul",
    "audience": "teacher",
    "developmentArea": null,
    "workMode": "group",
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "version": "2020",
      "cells": [
        "AC62"
      ]
    }
  },
  {
  "id": "teacher_support_zaman_yonetimi",
  "officialLabel": "Zaman Yönetimi",
  "audience": "teacher",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "RPDH_SUNUM_SISTEMI",
    "version": "2020",
    "cells": [
      "AC63"
    ]
  }
},

// =========================================================
// MEBBİS 2026-2027 — YENİ ÖĞRETMEN DMÖE FAALİYETLERİ
// =========================================================

{
  "id": "teacher_support_aile_ici_iletisim",
  "officialLabel": "Aile İçi İletişim",
  "audience": "teacher",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "teacher_support_hak_ve_sorumluluklarini_bilme",
  "officialLabel": "Hak ve Sorumluluklarını Bilme",
  "audience": "teacher",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "teacher_support_hayat_boyu_ogrenme",
  "officialLabel": "Hayat Boyu Öğrenme",
  "audience": "teacher",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "teacher_support_meslek_secerken_dikkat_edilmesi_gerekenler",
  "officialLabel": "Meslek Seçerken Dikkat Edilmesi Gerekenler",
  "audience": "teacher",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "teacher_support_okul_kurallari",
  "officialLabel": "Okul Kuralları",
  "audience": "teacher",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "teacher_support_okul_ve_cevresindeki_sosyokulturel_imkanlar",
  "officialLabel": "Okul ve Çevresindeki Sosyokültürel İmkanlar",
  "audience": "teacher",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "teacher_support_ogretmenlere_yonelik_bagimlilikla_mucadele_psikoegitim_programi",
  "officialLabel": "Öğretmenlere Yönelik Bağımlılıkla Mücadele Psikoeğitim Programı",
  "audience": "teacher",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "teacher_support_selamlasma",
  "officialLabel": "Selamlaşma",
  "audience": "teacher",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "teacher_support_siber_zorbalik",
  "officialLabel": "Siber Zorbalık",
  "audience": "teacher",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
},
{
  "id": "teacher_support_sosyal_uyum",
  "officialLabel": "Sosyal Uyum",
  "audience": "teacher",
  "developmentArea": null,
  "workMode": "group",
  "active": true,
  "source": {
    "system": "MEBBIS",
    "version": "2026-2027"
  }
}
];


// =========================================================
// YARDIMCI FONKSİYONLAR
// =========================================================

export const getTargetActivityById = (
  activityId
) => {

  return (
    TARGET_ACTIVITY_CATALOG.find(
      activity =>
        activity.id === activityId &&
        activity.active
    ) || null
  );
};


export const isOfficialTargetActivity = (
  activityId
) => {

  return TARGET_ACTIVITY_CATALOG.some(
    activity =>
      activity.id === activityId &&
      activity.active
  );
};


export const getTargetActivitiesByAudience = (
  audience,
  developmentArea = null
) => {

  return TARGET_ACTIVITY_CATALOG.filter(
    activity => {

      if (
        !activity.active
      ) {
        return false;
      }


      if (
        activity.audience !==
        audience
      ) {
        return false;
      }


      if (
        audience === "student" &&
        developmentArea &&
        activity.developmentArea !==
          developmentArea
      ) {
        return false;
      }


      return true;
    }
  );
};


export const getTargetActivityOptions = ({
  audience,
  developmentArea = null,
  search = ""
} = {}) => {

  const normalizedSearch =
    String(search || "")
      .trim()
      .toLocaleLowerCase(
        "tr-TR"
      );


  return getTargetActivitiesByAudience(
    audience,
    developmentArea
  )

    .filter(activity => {

      if (
        !normalizedSearch
      ) {
        return true;
      }


      return activity
        .officialLabel
        .toLocaleLowerCase(
          "tr-TR"
        )
        .includes(
          normalizedSearch
        );
    })

    .sort(
      (a, b) =>
        a.officialLabel
          .localeCompare(
            b.officialLabel,
            "tr"
          )
    );
};
